import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { getDossierDocuments } from "../../../api/document/getDossierDocuments";
import DossierSelector from "../../../components/dossier/DossierSelector";
import DocumentList from "../../../employer/components/DocumentList";
import { useDossierActivationCheck } from "../../../hooks/useDossierActivationCheck";
import { useApi } from "../../../providers/ApiProvider";
import { APQueryOptions } from "../../../providers/APQueryProvider";
import { DocumentFilters } from "../../../types/Document";

const DossierDocumentList = () => {
  const { dossierId } = useParams<{
    dossierId: string;
  }>();
  const { fetchFile } = useApi();

  const getDocuments = (filters: DocumentFilters, options?: APQueryOptions) => {
    return getDossierDocuments(dossierId || "", filters, options);
  };

  const { navigationCheckComplete, isLoading, isSuccess, activatedDossiers } =
    useDossierActivationCheck({
      dossierId,
    });

  const selectedDossier = activatedDossiers.find(
    (dossier) => dossier.id === dossierId
  );

  const handleDownload = async (documentId: string, fileName: string) => {
    fetchFile("getDossierDocumentPDF", dossierId || "", fileName, {
      queryParams: { documentId },
    });
  };

  return (
    <DocumentList
      key={dossierId}
      page={"dossierDocuments"}
      getDocuments={getDocuments}
      onDownload={handleDownload}
      isLoading={isLoading || !navigationCheckComplete}
      isSuccess={isSuccess && navigationCheckComplete}
      topCollapseContent={
        selectedDossier && (
          <Box mb={2}>
            <DossierSelector
              dossiers={activatedDossiers}
              selectedDossier={selectedDossier}
              redirectTo="dossierDocuments"
              showDivider
            />
          </Box>
        )
      }
    />
  );
};

export default DossierDocumentList;
